module.exports = __webpack_public_path__ + "img/close.a35fecea.svg";